/**
 * URL 参数数据增强器
 * 优先级：5（最低，兜底）
 * 职责：从 URL 参数获取数据
 */

import { DataEnricher, EnrichContext } from "./types";

export class URLEnricher implements DataEnricher {
  name = "URLEnricher";
  priority = 5; // 较低优先级，作为兜底

  shouldEnrich(context: EnrichContext): boolean {
    return typeof window !== "undefined"; // 总是尝试从 URL 获取
  }

  enrich(context: EnrichContext): Record<string, any> {
    const { trackData } = context;

    if (typeof window === "undefined") return trackData;

    const params = new URLSearchParams(window.location.search);

    // 从 URL 参数获取搜索词（如果还没有）
    if (!trackData.search_word && params.get("q")) {
      trackData.search_word = params.get("q") as string;
    }

    // 从 URL 获取其他参数（兜底）
    if (!trackData.source_page && params.get("source_page")) {
      trackData.source_page = params.get("source_page") as string;
    }

    if (!trackData.search_word_type && params.get("search_word_type")) {
      trackData.search_word_type = params.get("search_word_type") as string;
    }

    // 开发环境日志
    if (
      process.env.NODE_ENV === "development" &&
      Object.keys(trackData).some((key) => params.get(key))
    ) {
      console.log("[URLEnricher] Fallback to URL params:", {
        search_word: trackData.search_word,
        source_page: trackData.source_page,
      });
    }

    return trackData;
  }
}
